import { getCookie } from "@/utils";
import { IS_SERVER } from "@/misc/constants";

type CookieGetter = (name: string) => string | undefined;

const getLocale = (
  state: tReduxRootState,
  getCookieFn?: CookieGetter,
): string | undefined => {
  if (state.locale) {
    return state.locale;
  }
  if (IS_SERVER && getCookieFn) {
    // On the server, use the provided cookie getter function
    return getCookieFn("locale");
  } else {
    // On the client, use the browser cookie getter from utils
    return getCookie("locale");
  }
};

export const Selectors = {
  getLocale,
};

